import React from "react";
import { CheckIcon, TrophyIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images } from "../../data/content";
const perks = ["Lifetime digital access", "No monthly subscription", "No recurring fees", "Instant access", "7-day guarantee"];
export function Offer() {
  return <section id="offer" className="w-full bg-navy-deep px-4 py-16 sm:py-20" aria-labelledby="offer-title" data-id="element-192" data-mp="3a5yt02h7s75z">
      <div className="mx-auto max-w-2xl" data-id="element-193" data-mp="3f3qhsnmkbd5y">
        <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider text-gold-light" data-id="element-194" data-mp="3f2ff6r4usbgf">
          <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-195" data-mp="3nwu31i3g8ub5" />
          Special launch offer
        </p>
        <h2 id="offer-title" className="mt-3 text-center font-serif text-3xl font-bold leading-tight text-white sm:text-5xl" data-id="element-196" data-mp="3sw6qa3y8g3e9">
          Here's everything you'll receive today
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-197" data-mp="1klgm2m2qggkx">
          <img src={images.hero} alt="Complete Blepharoplasty Decision Lab bundle" className="block w-full bg-cream" data-id="element-198" data-mp="1kjdl5701l31f" />
          <div className="p-6 sm:p-8" data-id="element-199" data-mp="1bks81rdcag81">
            <h3 className="text-center font-serif text-2xl font-bold text-navy" data-id="element-200" data-mp="1bltjhwy9p4qa">Blepharoplasty Decision Lab™</h3>
            <dl className="mt-6 divide-y divide-navy/10 border-y border-navy/10" data-id="element-201" data-mp="16n0dsqp82i0o">
              <div className="flex items-center justify-between gap-4 py-3" data-id="element-202" data-mp="23awndbm8sd2e">
                <dt className="font-semibold text-ink" data-id="element-203" data-mp="1z9um6p8rlqxs">6 Premium Volumes</dt>
                <dd className="font-semibold text-muted" data-id="element-204" data-mp="1zcqnmnjtmxqz">$97</dd>
              </div>
              <div className="flex items-center justify-between gap-4 py-3" data-id="element-205" data-mp="1uhjn1olum96a">
                <dt className="font-semibold text-ink" data-id="element-206" data-mp="1pk1momlwd29w">5 Exclusive Professional Bonuses</dt>
                <dd className="font-semibold text-muted" data-id="element-207" data-mp="2n0ql06bn1mej">$197</dd>
              </div>
              <div className="flex items-center justify-between gap-4 py-3" data-id="element-208" data-mp="2i879dewih1cd">
                <dt className="font-extrabold uppercase text-ink" data-id="element-209" data-mp="314z0gmwj9zbk">Total value</dt>
                <dd className="text-xl font-extrabold text-alert line-through" data-id="element-210" data-mp="364kb3ul2fw44">$294</dd>
              </div>
            </dl>

            <p className="mt-6 text-center text-base text-muted" data-id="element-211" data-mp="2sdowe1nvyksm">But today, the complete Decision Lab™ is available for:</p>
            <p className="mt-1 text-center font-serif text-7xl font-extrabold leading-none text-cta sm:text-8xl" data-id="element-212" data-mp="2wdfxay74mhav">$27</p>
            <p className="mt-2 text-center text-sm font-bold uppercase tracking-wider text-navy" data-id="element-213" data-mp="2idoduhxuc8ph">One-time payment</p>

            <ul className="mx-auto mt-6 grid max-w-sm gap-2" data-id="element-214" data-mp="2nbpvqzjj61zd">
              {perks.map(p => <li key={p} className="flex items-center gap-2.5 text-[15px] font-medium text-ink" data-id="element-215" data-mp="29gnreguc0koo">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta/15" data-id="element-216" data-mp="2dhpsz4bq18tt">
                    <CheckIcon className="h-3.5 w-3.5 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-217" data-mp="bojfgufky6n4" />
                  </span>
                  {p}
                </li>)}
            </ul>

            <CtaButton label="Get the Decision Lab™ for $27" subtext="One-time payment · Instant digital access · Lifetime access · 7-day guarantee" className="mt-8" data-id="element-218" data-mp="1s4yxpjn23lbk" />

            <div className="mt-8 flex flex-col items-center gap-8 rounded-2xl bg-cream p-5" data-id="element-219" data-mp="215f16t3susgf">
              <Countdown data-id="element-220" data-mp="2fu1phkbemujs" />
              <ScarcityBar data-id="element-221" data-mp="2ft8gecoz3syh" />
            </div>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-xl text-center text-lg leading-relaxed text-white/80" data-id="element-222" data-mp="2aw9om0ss7y3g">
          You don't need another massive course. You need opportunities to actually work through cases — a reusable case-based training system you can return to whenever you want to practice.
        </p>
      </div>
    </section>;
}